/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { useAuth } from '@hooks';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { EnvelopeForm } from '../components/form/EnvelopeForm';

export const CreateEnvelope: React.FC = () => {
  const { hasLogin } = useAuth();

  useEffect(() => {
    // no-op: removed Bot guidance
  }, []);

  if (!hasLogin) {
    return <Navigate to="/profile" />;
  }

  return (
    <Box
      fontFamily="rootFont"
      width="100%"
      paddingTop={{ base: '4.5rem', md: '8rem' }}
    >
      <EnvelopeForm />
    </Box>
  );
};
